<template>
  <b-sidebar
    shadow
    visible
    backdrop
    no-header
    class="show"
    sidebar-class="cp-sidebar ps-sidebar auto"
    body-class="cp-sidebar__body"
    @change="$emit('clear')"
  >
    <SidebarHeader :title="title" @clear="$emit('clear')" />
    <div class="cp-sidebar__main">
      <b-form class="cp-sidebar__main__wrapper">
        <template v-if="isItemsStep">
          <SelectOrderItem :items="items" @updateItems="updateSelectedItems($event)" />
          <div class="order__item__btns" v-if="hasSelectedItems">
            <b-button class="cp-sidebar__btn no-outline-btn mt-0" variant="primary" @click.prevent.stop="goToNextStep(false)">
              <span v-if="hasSubscriptionItems">Buy One-time</span>
              <span v-else>Re-Order</span>
            </b-button>
          </div>
        </template>
        <template v-else-if="isAddressStep">
          <AddressInfo :address-prefix="'ship_'" />
          <b-button class="cp-sidebar__btn no-outline-btn mt-0" variant="primary" @click.prevent.stop="goToNextStep()">
            Continue To Payment Method
            <svg class="cp-sidebar__btn__ricon" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path d="M13.0623 5.25L19.8123 12L13.0623 18.75M18.8748 12H3.9873" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </b-button>
        </template>
        <template v-else-if="isPaymentStep">
          <PaymentMethod />
          <b-button class="cp-sidebar__btn no-outline-btn mt-0" variant="primary" @click.prevent.stop="goToNextStep()">
            Complete My Order
            <svg class="cp-sidebar__btn__ricon" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path d="M13.0623 5.25L19.8123 12L13.0623 18.75M18.8748 12H3.9873" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </b-button>
        </template>
        <template v-else-if="isOrderCompleted">
          <OrderSuccess :subscription="isSubscriptionOrder" />
          <b-button class="cp-sidebar__btn no-outline-btn mt-0" variant="primary" @click.prevent.stop="reset()">
            Continue
          </b-button>
        </template>
      </b-form>
    </div>
  </b-sidebar>
</template>

<script>

import SelectOrderItem from '@/components/Order/SelectOrderItem'
import {CheckoutSteps, CheckoutStepsTitle} from '@/constants'
import {isRecurring, prepareCartItems} from '@/utils'
import AddressInfo from '@/components/Order/AddressInfo'
import PaymentMethod from '@/components/PaymentInfo/PaymentMethod'
import OrderSuccess from '@/components/Order/OrderSuccess'
import {mapState} from 'vuex'
import SidebarHeader from '@/components/Sidebar/SidebarHeader.vue'

export default {
  name: 'OrderCheckout',
  components: {SidebarHeader, OrderSuccess, PaymentMethod, AddressInfo, SelectOrderItem},
  props: {
    items: Array,
    currency: String,
    isSubscription: Boolean,
    skipInitial: Boolean
  },
  data: function() {
    return {
      title: '',
      selectedItems: [],
      isSubscriptionOrder: false,
      activeCheckoutStep: CheckoutSteps.SelectItems
    }
  },
  computed: {
    ...mapState(['cart', 'campaign']),
    hasSubscriptionItems: function() {
      return this.campaign.portal_settings.allow_reactivate_subscription && this.selectedItems &&
        this.selectedItems.every((selectedItem) => isRecurring(selectedItem) && selectedItem.can_reactivate_subscription)
    },
    hasSelectedItems: function() {
      return this.selectedItems && this.selectedItems.some((selectedItem) => selectedItem.selected)
    },
    isItemsStep: function() {
      return this.activeCheckoutStep === CheckoutSteps.SelectItems
    },
    isAddressStep: function() {
      return this.activeCheckoutStep === CheckoutSteps.AddressInfo
    },
    isPaymentStep: function() {
      return this.activeCheckoutStep === CheckoutSteps.PaymentInfo
    },
    isOrderCompleted: function() {
      return this.activeCheckoutStep === CheckoutSteps.OrderPlaced
    }
  },
  methods: {
    updateSelectedItems: function(items) {
      this.selectedItems = items
    },
    addToCart: function() {
      const cart = this.cart || []
      const items = prepareCartItems(cart, {products: this.selectedItems, checkout: true})
      if (items.length > 0) {
        this.$store.commit('busy')
        this.$store.dispatch('add_cart', items)
          .then(() => {
            this.$store.commit('ready')
            this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
          })
          .catch(err => {
            let errorMessage = ''
            if (err.response.status === 400) {
              errorMessage = err.response.data['items']
            }
            this.$store.commit('error', errorMessage || err)
            this.$store.commit('ready')
          })
      } else {
        this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
      }
    },
    goToNextStep: function(isSubscription) {
      switch (this.activeCheckoutStep) {
        case CheckoutSteps.SelectItems:
          this.addToCart()
          this.activeCheckoutStep = CheckoutSteps.AddressInfo
          this.isSubscriptionOrder = isSubscription
          break

        case CheckoutSteps.AddressInfo:
          this.activeCheckoutStep = CheckoutSteps.PaymentInfo
          break

        case CheckoutSteps.PaymentInfo:
          this.activeCheckoutStep = CheckoutSteps.OrderPlaced
          break

        default:
          this.activeCheckoutStep = CheckoutSteps.SelectItems
      }
      if (this.activeCheckoutStep !== CheckoutSteps.OrderPlaced) {
        this.title = CheckoutStepsTitle[this.activeCheckoutStep]
      } else {
        this.title = this.isSubscriptionOrder ? 'Re-Activate Subscription' : 'Re-Ordered'
      }
    },
    reset: function() {
      this.$emit('clear')
      this.selectedItems = []
      this.title = ''
      this.isSubscriptionOrder = false
      this.activeCheckoutStep = CheckoutSteps.SelectItems
    }
  },
  mounted() {
    if (this.skipInitial) {
      this.goToNextStep(this.isSubscription)
    } else {
      this.title = CheckoutStepsTitle[this.activeCheckoutStep]
    }
  }

}
</script>

<style scoped>

</style>
